(function() {
  var STORAGE_KEY_DK = 'asim_jofa_collection_cols_desktop_v2';
  var STORAGE_KEY_MB = 'asim_jofa_collection_cols_mobile';
  var LEGACY_KEY = 'asim_jofa_collection_cols';

  function isDesktop() {
    return window.innerWidth >= 769;
  }

  function getStoredCols() {
    try {
      if (isDesktop()) {
        var dkVal = localStorage.getItem(STORAGE_KEY_DK);
        if (dkVal === '1' || dkVal === '2' || dkVal === '3') {
          return dkVal;
        }
        return '2'; // Default box 2: 4 cards on desktop
      } else {
        var mbVal = localStorage.getItem(STORAGE_KEY_MB);
        if (mbVal === '1' || mbVal === '2' || mbVal === '3') {
          return mbVal;
        }
        var legacy = localStorage.getItem(LEGACY_KEY);
        if (legacy === '1' || legacy === '2' || legacy === '3') {
          return legacy;
        }
        return '2'; // Default box 2: 2 cards on mobile
      }
    } catch (e) {}
    return isDesktop() ? '2' : '2';
  }

  function setStoredCols(cols) {
    try {
      if (isDesktop()) {
        localStorage.setItem(STORAGE_KEY_DK, cols);
      } else {
        localStorage.setItem(STORAGE_KEY_MB, cols);
        localStorage.setItem(LEGACY_KEY, cols);
      }
    } catch (e) {}
  }

  function updateButtonLabels() {
    var dk = isDesktop();
    var btn1 = document.querySelector('.hdt-custom-layout-switch .hdt-layout-btn[data-cols="1"]');
    var btn2 = document.querySelector('.hdt-custom-layout-switch .hdt-layout-btn[data-cols="2"]');
    var btn3 = document.querySelector('.hdt-custom-layout-switch .hdt-layout-btn[data-cols="3"]');
    if (btn1) {
      var t1 = dk ? '3 products per row' : '1 product per row';
      btn1.setAttribute('title', t1);
      btn1.setAttribute('aria-label', t1);
    }
    if (btn2) {
      var t2 = dk ? '4 products per row' : '2 products per row';
      btn2.setAttribute('title', t2);
      btn2.setAttribute('aria-label', t2);
    }
    if (btn3) {
      var t3 = dk ? '5 products per row' : '3 products per row';
      btn3.setAttribute('title', t3);
      btn3.setAttribute('aria-label', t3);
    }
  }

  function applyLayout(cols) {
    if (!cols) cols = getStoredCols();
    
    document.documentElement.setAttribute('data-collection-cols', cols);

    document.querySelectorAll('.hdt-custom-layout-switch .hdt-layout-btn').forEach(function(btn) {
      if (btn.getAttribute('data-cols') === cols) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });

    document.querySelectorAll('.hdt-collection-products').forEach(function(grid) {
      grid.setAttribute('data-active-layout', cols);
    });

    updateButtonLabels();

    try {
      // Map box 1 -> 1.2.3, box 2 -> 2.3.4, box 3 -> 3.4.5 (mobile.tablet.desktop)
      var cNum = parseInt(cols, 10) || 2;
      var cartCols = cNum + '.' + (cNum + 1) + '.' + (cNum + 2);
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { products_items_per_row: cartCols } }),
          keepalive: true
        }).catch(function() {});
      }
    } catch (e) {}
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hdt-custom-layout-switch .hdt-layout-btn');
    if (!btn) return;
    
    e.preventDefault();
    var cols = btn.getAttribute('data-cols');
    if (cols) {
      setStoredCols(cols);
      applyLayout(cols);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyLayout();
    });
  } else {
    applyLayout();
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      applyLayout();
    }, 100);
  });

  document.addEventListener('facet:render', function() {
    setTimeout(applyLayout, 20);
  });
  document.addEventListener('products:update', function() {
    setTimeout(applyLayout, 20);
  });
  window.addEventListener('pageshow', function() {
    applyLayout();
  });
})();
